export const TERMS_AND_CONDITIONS_CONTENT_TYPES = {
  orderedList: 'ol',
  unorderedList: 'ul',
  innerBlock: 'block',
  footer: 'footer'
}
